import PricesField from './PricesField.component';

export default PricesField;
